// Copyright 2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import DeploymentFormBody from "./DeploymentFormBody";

export default DeploymentFormBody;
